import { get, post, put, del } from "@/shared/utils/fetchApi";
import type { MindChange, MindSettings, SoulVersion } from "../types/BrainTypes";

/** Soul (histórico) e Mind (cadeado, trilha, desfazer) — AB#86817. */
export class BrainService {
  /** A Soul atual (a última versão); `version: null` quando ainda não existe. */
  static getSoul(workspaceId: string): Promise<SoulVersion | { version: null; content: string }> {
    return get(`/products/${workspaceId}/soul`);
  }

  static saveSoul(workspaceId: string, content: string): Promise<unknown> {
    return put(`/products/${workspaceId}/soul`, { content });
  }

  static getSoulVersions(workspaceId: string): Promise<SoulVersion[]> {
    return get<SoulVersion[]>(`/products/${workspaceId}/soul/versions`);
  }

  static restoreSoulVersion(workspaceId: string, version: number): Promise<unknown> {
    return post(`/products/${workspaceId}/soul/versions/${version}/restore`, {});
  }

  static setBlockLock(workspaceId: string, blockId: string, locked: boolean): Promise<unknown> {
    const url = `/products/${workspaceId}/mind/blocks/${blockId}/lock`;
    return locked ? post(url, {}) : del(url);
  }

  /** Quanto da Mind entra no brain_load, em caracteres. */
  static getMindSettings(workspaceId: string): Promise<MindSettings> {
    return get<MindSettings>(`/products/${workspaceId}/mind/settings`);
  }

  static saveMindSettings(workspaceId: string, settings: MindSettings): Promise<MindSettings> {
    return put<MindSettings>(`/products/${workspaceId}/mind/settings`, settings);
  }

  static getMindChanges(workspaceId: string): Promise<MindChange[]> {
    return get<MindChange[]>(`/products/${workspaceId}/mind/changes`);
  }

  static undoMindChange(workspaceId: string, changeId: string): Promise<unknown> {
    return post(`/products/${workspaceId}/mind/changes/${changeId}/undo`, {});
  }
}
